
import React, { useEffect } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { useChatMessages } from "@/hooks/useChatMessages";
import { ChatMessageList } from "@/components/notifications/chat/ChatMessageList";
import { ChatInput } from "@/components/notifications/chat/ChatInput";
import { useAuth } from "@/context/AuthContext";
import { MessageCircle } from "lucide-react";

interface NotificationChatProps {
  notification: {
    id: string;
    [key: string]: any;
  };
}

const NotificationChat = ({ notification }: NotificationChatProps) => {
  const { user } = useAuth();
  
  const {
    messages,
    loading,
    newMessage,
    setNewMessage,
    editingMessage,
    setEditingMessage,
    editText,
    setEditText,
    sendMessage,
    editMessage,
    deleteMessage,
    showEmojiPicker,
    setShowEmojiPicker,
    addEmoji,
    updateReadStatus,
    selectedFile,
    filePreview,
    handleFileSelect,
    handleFileClear,
    uploading
  } = useChatMessages(notification.id);

  // Mark messages as read when the component mounts and when new messages come in
  useEffect(() => {
    if (user?.id && notification.id) {
      updateReadStatus();
    }
  }, [notification.id, user?.id, messages.length, updateReadStatus]);
  
  return (
    <Card className="border-t">
      <CardHeader className="pb-3">
        <CardTitle className="text-lg flex items-center">
          <MessageCircle className="mr-2 h-5 w-5" />
          Berichtgeving
        </CardTitle>
      </CardHeader>
      
      <CardContent className="p-0">
        <ChatMessageList 
          messages={messages} 
          loading={loading}
          currentUserId={user?.id || ''}
          onEditStart={(messageId, text) => {
            setEditingMessage(messageId);
            setEditText(text);
          }}
          onDelete={deleteMessage}
          products={notification.products}
        />
        
        <ChatInput 
          newMessage={newMessage}
          setNewMessage={setNewMessage}
          sendMessage={sendMessage}
          showEmojiPicker={showEmojiPicker}
          setShowEmojiPicker={setShowEmojiPicker}
          addEmoji={addEmoji}
          editingMessage={editingMessage}
          editText={editText}
          setEditText={setEditText}
          cancelEdit={() => setEditingMessage(null)}
          saveEdit={(messageId) => {
            if (messageId) {
              editMessage(messageId, editText);
            }
          }}
          selectedFile={selectedFile}
          filePreview={filePreview}
          onFileSelect={handleFileSelect}
          onFileClear={handleFileClear}
          uploading={uploading}
        />
      </CardContent>
    </Card>
  );
};

export default NotificationChat;
